module.exports = __webpack_public_path__ + "static/media/rick.c8022463.png";